
<button [matMenuTriggerFor]="menu"  class="circle-options-button">
    <mat-icon>more_horiz</mat-icon>
  </button>
  
  <mat-menu #menu="matMenu">
    <button *ngIf="showDetails" mat-menu-item (click)="goToDetails()">Details</button>

    <button mat-menu-item (click)="startNotebook()" 
      [disabled]="notebook.status.toLowerCase() !== notebookStatusLabels['stopped'].toLowerCase() &&
      notebook.status.toLowerCase() !== notebookStatusLabels['failed'].toLowerCase()"
    >Start</button>

    <button mat-menu-item (click)="stopNotebook()" 
    [disabled]="notebook.status.toLowerCase()!== notebookStatusLabels['running'].toLowerCase()"
    >Stop</button>

    <button mat-menu-item (click)="deleteNotebook()" 
    [disabled]="notebook.status.toLowerCase()!== notebookStatusLabels['stopped'].toLowerCase() &&
    notebook.status.toLowerCase()!== notebookStatusLabels['failed'].toLowerCase()"
    >Delete</button>
  </mat-menu>
  